export default "__VITE_ASSET__Bn5LHJjt__"